import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import { FaCoins, FaHandHoldingUsd, FaUniversity, FaUserTie } from "react-icons/fa";
import "./About.css";

const specialties = [
  { icon: FaCoins, label: "Gold Loans" },
  { icon: FaHandHoldingUsd, label: "Personal Loans" },
  { icon: FaUniversity, label: "Business Loans" },
  { icon: FaUserTie, label: "Financial Assistance" },
];

const stats = [
  { value: 10, suffix: "+", label: "Years Experience" },
  { value: 5000, suffix: "+", label: "Happy Customers" },
  { value: 24, suffix: "hr", label: "Fast Loan Approval" },
  { value: 100, suffix: "%", label: "Trusted Service" },
];

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.floor(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <span ref={ref} className="lf-about__stat-value">
      {display}
      {suffix}
    </span>
  );
};

const About = () => {
  return (
    <section id="about" className="section lf-about">
      <div className="container">
        <div className="lf-about__layout">
          <motion.div
            className="lf-about__card"
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="eyebrow">Who We Are</span>
            <h2 className="section-heading">
              About <span className="accent-text">LENT FINANCE</span>
            </h2>
            <p className="section-subtext">
              LENT FINANCE provides trusted financial services with transparent policies
              and quick loan approvals. We work closely with every customer to make
              borrowing simple, fair, and fast.
            </p>

            <div className="lf-about__specialties">
              {specialties.map(({ icon: Icon, label }, i) => (
                <motion.div
                  key={label}
                  className="lf-about__specialty"
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <span className="lf-about__specialty-icon">
                    <Icon />
                  </span>
                  <span>{label}</span>
                </motion.div>
              ))}
            </div>

            <div className="lf-about__tags">
              <span>Fast Processing</span>
              <span>Customer Satisfaction</span>
            </div>
          </motion.div>

          <motion.div
            className="lf-about__stats"
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
          >
            {stats.map((stat, i) => (
              <motion.div
                key={stat.label}
                className="lf-about__stat-card"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.55, delay: i * 0.12 }}
                whileHover={{ y: -6 }}
              >
                <Counter value={stat.value} suffix={stat.suffix} />
                <span className="lf-about__stat-label">{stat.label}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
